/**
 * Open browser window.
 * @param {string} url
 * @param {number} height
 * @param {number} width
 * @returns {function}
 */
const windowOpen = (url, height = 400, width = 550) => {
    const config = {
        height,
        width,
        location: "no",
        toolbar: "no",
        status: "no",
        directories: "no",
        menubar: "no",
        scrollbars: "yes",
        resizable: "no",
        centerscreen: "yes",
        chrome: "yes",
        top: (window.screen.height - height) / 2,
        left: (window.screen.width - width) / 2,
    };

    if (url) {
        window.open(
            url,
            "",
            Object.keys(config)
                .map((key) => `${key}=${config[key]}`)
                .join(", "),
        );
    }
};

export default windowOpen;
